import * as Configuration from '../app.constants.js';

export class MediasService {
  constructor($uibModal, $mdDialog, $http, LoginFactory, AsyncRequestFactory) {
    this.$uibModal = $uibModal;
    this.$mdDialog = $mdDialog;
    this.$http = $http;
    this.LoginFactory = LoginFactory;
    this.AsyncRequestFactory = AsyncRequestFactory;
  }


  pictureZoomMaterial(mediaSrc, mediaType) {
    this.$mdDialog.show({
      'multiple': true,
      'clickOutsideToClose': true,
      'locals': {
        'mediaSrc': mediaSrc,
        'mediaType': mediaType
      },
      'template': `
      <md-dialog>
        <md-toolbar>
          <div class="md-toolbar-tools">
            <span flex/>
            <md-button class="md-icon-button" ng-click="ok()"><md-icon>close</md-icon></md-button>
          </div>
        </md-toolbar>
        <md-dialog-content>
          <img ng-if="mediaType === 'picture'" jwt-src="{{ mediaSrc }}"></img>
          <video ng-if="mediaType === 'video'"
                 jwt-src="{{ mediaSrc }}"
                 preload
                 controls
          ></video>
        </md-dialog-content>
      </md-dialog>`,
      controller: ['$scope', '$mdDialog', 'mediaSrc', 'mediaType',
        function ($scope, $mdDialog, mediaSrc, mediaType) {
          $scope.mediaSrc = mediaSrc;
          $scope.mediaType = mediaType;
          $scope.ok = () => $mdDialog.hide('ok');
        }]
    });
  }

  pictureZoom(imgUrl) {
    this.$uibModal.open({
      animation: false,
      template: `
          <div class="modal-body">
            <div class="img-container-zoom col-md-11 col-sm-11 col-xs-11">
              <img class="img-responsive" jwt-src="{{imgUrl}}"></img>
            </div>
          </div>
          <div style="clear:both;" class="modal-footer">
            <button class="btn btn-lg btn-alcmeon-std" id="ok" ng-click="ok();" translate-once="form/ok"></button>
          </div>
           `,
      resolve: {
        imgUrl: function () {
          return imgUrl;
        }
      },
      controller: ['$scope', '$uibModalInstance', 'imgUrl', function ($scope, $uibModalInstance, imgUrl) {
        init();
        $scope.ok = ok;
        function init() {
          $scope.imgUrl = imgUrl;
        }
        function ok() {
          $uibModalInstance.close('ok');
        }
      }]
    });
  }

  /**
   * @deprecated
   * migrated in medias.service.ts
   * Prefer to use checkLimitationsAndUpload instead and pass the options through the first param object
   *
   * @remarks supported options are companyId, siteId, mediaType, file, mediaLimitations.
   */
  upload2(companyId, siteId, mediaType, file, ok, fail, progress) {
    let endpoint = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/medias';
    if (mediaType === 'file') {
      endpoint = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/file-upload';
    }
    this._doUpload(mediaType, file, endpoint, this.LoginFactory.getJwt(), ok, fail, progress);
  }

  /**
   * @deprecated migrated in medias.service.ts
   *
   * Allows to upload the given file only if the media limitations are respected.
   * The allowed options are companyId, siteId, mediaType, file, mediaLimitations.
   * @param {*} ok the function callback in case of success.
   * @param {*} fail  the function callback in case of error.
   * @param {*} progress  the function callback while performing the action.
   */
  checkLimitationsAndUpload(options, ok, fail, progress) {
    const { companyId, siteId, mediaType, file, mediaLimitations, uploadAsync } = options;
    try {
      this._checkLimitations(mediaLimitations, mediaType, file);
      if (uploadAsync) {
          this._uploadAsync(companyId, siteId, mediaType, file)
          .then(
            ({status, data}) => ok({ status, data }),
            ({status, data}) => fail({status, data})
          );
      } else {
        this.upload2(companyId, siteId, mediaType, file, ok, fail, progress);
      }
    } catch (error) {
      fail({ data: { error: error.translationPath, translationData: error.translationData } });
      return false;
    }
  }

  /**
   * @deprecated migrated in medias.service.ts
   */
  _checkLimitations(mediaLimitations, mediaType, file) {
    if (!mediaLimitations) {
      return;
    }
    const { size, type } = file;

    const checkWeight = (weight) => {
      if (weight) {
        const maxWeight = (weight || 0) * 1024 * 1024;
        if (maxWeight && size > maxWeight) {
          const translationPath = 'media/upload/too-big/limitation';
          const translationData = { max_size: weight };
          throw { translationPath, translationData };
        }
      }
    }
    
    const checkSupportedTypes = (supportedTypes) => {
      if (!['video/*', 'image/*'].includes(supportedTypes)) {
        const supportedContentTypes = supportedTypes?.split(',');
        if (supportedContentTypes?.length && !supportedContentTypes.includes(type)) {
          const translationPath = 'media/upload/wrong-format/limitation';
          const translationData = { supported_types: supportedTypes };
          throw { translationPath, translationData };
        }
      }
    }

    if (mediaType === 'image') {
      checkSupportedTypes(mediaLimitations.imageMimeTypes);
      checkWeight(mediaLimitations.imageMaxSizeMb);
    } else if (mediaType === 'video') {
      checkSupportedTypes(mediaLimitations.videoSupportedTypes);
      checkWeight(mediaLimitations.videoMaxSizeMb);
    } else if (mediaType === 'file') {
      checkSupportedTypes(mediaLimitations.fileMediaTypes);
      checkWeight(mediaLimitations.fileMaxSizeMb);
    }
  }

  uploadAccountProfilePicture2(companyId, userId, file, ok, fail, progress) {
    const endpoint = this.accountProfilePictureEndpoint(companyId, userId);
    this._doUpload('site-profile-attachment', file, endpoint, this.LoginFactory.getJwt(), ok, fail, progress);
  }

  deleteAccountProfilePicture(companyId, userId) {
    const endpoint = this.accountProfilePictureEndpoint(companyId, userId);
    return this.$http.delete(endpoint);
  }

  uploadWhatsappProfilePhoto(companyId, siteId, file, ok, fail, progress) {
    const endpoint = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/whatsapp/profile/photo';
    this._doUpload('whatsapp-profile-photo', file, endpoint, this.LoginFactory.getJwt(), ok, fail, progress);
  }

  /**
   * @deprecated migrated in medias.service.ts
   */
  _doUpload(mediaType, file, endpoint, jwt, ok, fail, progress) {
    // We do not use $http because we can't get progress updates from $http
    var fd = new FormData();
    fd.append("media_type", mediaType);
    fd.append("file_name", file.name);
    fd.append("file", file);
    let request = new XMLHttpRequest();
    if (progress) {
      request.upload.onprogress = function (e) {
        let percent = (e.loaded / e.total) * 100;
        progress(percent);
      };
    }
    request.onload = function () {
      let resp = JSON.parse(request.response);
      if (request.status == 200) {
        ok({ status: request.status, data: resp });
      } else {
        fail({ status: request.status, data: resp });
      }
    };
    request.onerror = function () {
      fail({ status: -1, data: { 'error': 'media/upload/unexpected-error' } });
    };
    request.open('POST', endpoint, true);
    request.setRequestHeader('Authorization', 'Bearer ' + jwt);
    request.send(fd);
    return request;
  }

  cancelUpload2(request) {
    request.abort();
  }

  /**
   * @deprecated migrated in publication.service.ts
   */
  checkMediaUpload(companyId, siteId, mediaId, mediaType) {
    const url = Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/medias/' + mediaId +
      '/check-upload';

    const data = {
      'media_type': mediaType
    };

    return this.AsyncRequestFactory.post(companyId, url, data);
  }

  /**
   * @deprecated migrated in medias.service.ts
   */
  _uploadAsync(companyId, siteId, mediaType, file) {
    const url = Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios/medias';

    var fd = new FormData();
    fd.append("media_type", mediaType);
    fd.append("file_name", file.name);
    fd.append("file", file);
    const headers = { 'Content-Type': undefined }; // Alows to disable the content type application/json and let the transaction defines form data multipart.

    return this.AsyncRequestFactory.post(companyId, url, fd, headers);
  }
  
  /**
   * @deprecated migrated in medias.service.ts
   */
  pictureUrl(companyId, pictureId) {
    if (pictureId) {
      return Configuration.constants.baseUrl + companyId + '/pictures/' + pictureId;
    }
  }

  videoUrl(companyId, videoId) {
    if (videoId) {
      return Configuration.constants.baseUrl + companyId + '/videos/' + videoId;
    }
  }

  accountProfilePictureEndpoint(companyId, userId) {
    return Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/users/' + userId + '/profile/picture';
  }

  fileUrl(companyId, fileId) {
    return Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/file-upload/' + fileId;
  }



  /**
   * Get a picture url with a short lived JWT
   * joint diagram elements don't have access to jwt-src (they are not angularjs templates)
   */
  pictureUrlWithJWT(companyId, pictureId) {
    if (pictureId) {
      return new Promise((resolve) => {
        const url = Configuration.constants.baseUrl + companyId + '/pictures/' + pictureId;
        this.LoginFactory.addJwtShortToUrl(url).then((urlWithJwt) => {
          resolve(urlWithJwt);
        });
      });
    } else {
      return new Promise((resolve) => {
        resolve(null);
      });
    }
  }

  /**
   * Get a video url with a short lived JWT
   */
  videoUrlWithJWT(companyId, videoId) {
    if (videoId) {
      return new Promise((resolve) => {
        const url = Configuration.constants.baseUrl + companyId + '/videos/' + videoId;
        this.LoginFactory.addJwtShortToUrl(url).then((urlWithJwt) => {
          resolve(urlWithJwt);
        });
      });
    } else {
      return new Promise((resolve) => {
        resolve(null);
      });
    }
  }

  /**
   * Download a file after adding a short lived jwt to its url
   * @deprecated use angular version in medias.service.ts
   */
  downloadFile(fileUrl, fileName) {
    this.LoginFactory.addJwtShortToUrl(fileUrl).then((urlWithJwt) => {
      // it's the only way, in full JS, to force download a file the browser could display itself (like .txt)
      // otherwise it must be in HTML with "download" attribute, or server side
      // (open a new tab in localhost and do not download, but ok when front is on server)
      let a = document.createElement('a');
      a.href = urlWithJwt;
      a.download = fileName || '0';
      a.click();
    });
  }

  downloadBinaryBase64(content, content_type, content_filename) {
    const bytes = Uint8Array.from(window.atob(content), c => c.charCodeAt(0))
    const blob = new Blob([bytes], { type: content_type });
    const element = document.createElement('a');
    element.href = URL.createObjectURL(blob);
    element.download = content_filename;
    element.click();
  }

  uploadSubbotExcel(companyId, siteId, data, ok, fail, progress) {
    let endpoint = null;
    if (data.subbotMode == 'internal') {
      endpoint = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/subbot/upload-excel-file?subbot_name=' + data.subbotName + '&excel_parameter=' + data.parameterName;
    } else {
      endpoint = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/application/' + data.applicationId + '/subbot/upload-excel-file?subbot_name=' + data.subbotName + '&excel_parameter=' + data.parameterName;
    }
    this._doUpload('file', data.file, endpoint, this.LoginFactory.getJwt(), ok, fail, progress);
  }

  afterUploadSubbotExcel(companyId, url) {
    return this.AsyncRequestFactory.post(companyId, url);
  }

  static MediasFactory($uibModal, $mdDialog, $http, LoginFactory, AsyncRequestFactory) {
    return new MediasService($uibModal, $mdDialog, $http, LoginFactory, AsyncRequestFactory);
  }
}
MediasService.MediasFactory.$inject = ['$uibModal', '$mdDialog', '$http', 'LoginFactory', 'AsyncRequestFactory'];
